<template>
  <div class="my-5">
    <div class="listing-header">
        <router-link to="/dashboard/add_posts" class="btn btn-primary">Add post</router-link>
    </div>
    <table class="table table-striped table-bordered">
      <tr>
        <th width="25%">Title</th>
        <th width="45%">Description</th>
        <th width="5%">Rating</th>
        <th width="5%">Views</th>
        <th width="20%">Action</th>
      </tr>
      <tr v-for="(post, index) in posts" :key="index">
        <td>{{post.title}}</td>
        <td>{{post.desc}}</td>
        <td>{{post.views}}</td>
        <td>{{post.rating}}</td>
        <td>
          <div><router-link :to="`/dashboard/edit_posts/${post.id}`" style="float:left;" class="btn btn-dark">Edit</router-link></div>
          <div class="btn btn-dark ml-1" @click="deleteHandler(post.id)" data-toggle="modal" data-target="#postDelete">Delete</div>
        </td>
      </tr>
    </table>
    <!-- Modal -->
    <div class="modal fade" id="postDelete" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body text-center">
            <button type="button" id="delete-modal-close" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <h5 class="mb-3">Delete Confirmation</h5>
            <p>Are you sure you want to delete this post ? ( there is no turning back )</p>
            <button class="btn btn-primary mx-3" @click="onConfirm" data-dismiss="modal">Yes, delete</button>
            <button class="btn btn-primary mx-3" @click="onCancel" data-dismiss="modal">No, do not delete it</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      confirmDelete: false,
      toDelete: null
    };
  },
  computed: {
    posts() {
      let posts = this.$store.getters["admin/getAdminPosts"];

      return posts;
    }
  },
  methods: {
    deleteHandler(id) {
      this.toDelete = id;
      this.confirmDelete = true;
    },
    onConfirm() {
      this.$store.dispatch("admin/deletePost", this.toDelete);
      this.confirmDelete = false;
    },
    onCancel() {
      this.toDelete = "";
      this.confirmDelete = false;
    }
  },
  created() {
    this.$store.dispatch("admin/getAdminPost");
  }
};
</script> 